import DapDSTooltip from './tooltip.component'

export * from './tooltip.component'
export default DapDSTooltip

DapDSTooltip.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-tooltip': DapDSTooltip
  }
}
